import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalSearchResponse } from '../models/response/global-search.response';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  baseURL = `${environment.voiceAPIConfig.uri}/global-search?`;

  constructor(private http: HttpClient) {}

  search(query: string): Observable<GlobalSearchResponse> {
    return this.http.get<GlobalSearchResponse>(`${this.baseURL}q=${encodeURIComponent(query)}`);
  }
}


